module.exports = __webpack_public_path__ + "61c6f4afe657a9bc34796f5a651426d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/walibi-holland-webfont.svg
// module id = 29
// module chunks = 0